import {createAsyncThunk} from '@reduxjs/toolkit';
import getReviewPrompts, {
    type ReviewPrompt,
} from 'api/facilities/get-review-prompts';

/**
 * Fetches the active driver-feedback review prompts (distinct by prompt text).
 * Populates the "Driver Selected Tag" multiselect in the verbatim-reviews
 * FiltersDrawer.
 *
 * Action Type: 'facilities/getReviewPromptsData'
 *
 * API Service: {@link getReviewPrompts}
 */
export const getReviewPromptsData = createAsyncThunk<ReviewPrompt[], void>(
    'facilities/getReviewPromptsData',
    async (_, {rejectWithValue}) => {
        try {
            const response = await getReviewPrompts();

            return response;
        } catch (err) {
            return rejectWithValue(err);
        }
    }
);
